import React from 'react';
import { Button } from 'reactstrap';

const CancelIconButton = ({ ...props }) => (
  <Button color="primary" outline {...props}>
    <i className="fa fa-times text-danger" />
  </Button>
);

CancelIconButton.propTypes = {
  ...Button.propTypes,
};

export { CancelIconButton };
